/**
 * Resolve a stored image path for use in img src or CSS url().
 * Absolute Blob URLs and frontend static files are returned as-is.
 * Legacy backend paths such as /avatars/ are prefixed with the API host.
 */
export function resolveMediaUrl(url) {
  if (!url) return null;
  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('/games/') ||
    url.startsWith('blob:') ||
    url.startsWith('data:')
  ) {
    return url;
  }
  const base = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${base}${path}`;
}
